// tslint:disable-next-line:max-line-length
import { Component, EventEmitter, Input, OnInit, Output, ViewChild, AfterViewInit, OnChanges,  OnDestroy } from '@angular/core';
import { SimpleTravel, BoardUpgrade, SimpleTravelAccommodation, FromAirport, SimpleTravelRoomTypePrice, SimpleTravelRoomType } from '../product.types';
import { BoardType, ProductType, Region, Country } from '../../core/core.types';
import {StaticService} from '../../core/static.service';
import {Observable} from 'rxjs/Rx';
import { SupplierService } from '../supplier.service';
import { SimpleTravelService } from '../simple-travel.service';
import {NavigationEnd, ActivatedRoute,  Router,  Params} from '@angular/router';
import { LoginFormComponent } from '../../users/login-form/login-form.component';
import { ToastrService } from 'ngx-toastr';

import { DatePipe } from '@angular/common';
import { SimpleTravelFormRoomTypeComponent } from '../simple-travel-form-room-types/simple-travel-form-room-types.component';
import { SimpleTravelFormAirportsComponent } from '../simple-travel-form-airports/simple-travel-form-airports.component';
import { SimpleTravelFormBoardUpgradesComponent } from '../simple-travel-form-board-upgrades/simple-travel-form-board-upgrades.component';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ReplaySubject } from 'rxjs/ReplaySubject';
import { AngularLoadingBarService } from 'ng4-loader-bar';
import { Translations } from '../../../assets/translations';
import { TranslateService } from '@ngx-translate/core';

import { SharedService } from '../../shared/shared.service';
import { BasicTravel, BasicSimpleTravelAccommodation } from '../basic.travel';
import { BasicFunctionsComponent } from '../../shared/basic.functions';


@Component({
  selector: 'b4a-product-simple-travel-form',
  templateUrl: './simple-travel-form.component.html',
   styleUrls: ['./simple-travel-form.component.css'],
})
export class SimpleTravelFormComponent extends BasicFunctionsComponent implements OnInit {

  defaultLanguage;
  // for blocking UI
  spinnerLoading = false;
  showGallery = false;
  enableUpload = false;
  file;

  // sessionData
  sessionData;

  // user type which determinates if user is premium or standard
  userType; // this.sharedService.getUserTravel()
  premium: boolean; // if user type is simpleTravel premium will be true else premium will be false

  // pagination array for images
  imagesArray: any[];

  // translations
  translations;

  nameOffile: any;
  image: any;

  @ViewChild(SimpleTravelFormRoomTypeComponent) roomComponent: SimpleTravelFormRoomTypeComponent;
  @ViewChild(SimpleTravelFormAirportsComponent) airportComponent: SimpleTravelFormAirportsComponent;
  @ViewChild(SimpleTravelFormBoardUpgradesComponent) boardComponent: SimpleTravelFormBoardUpgradesComponent;

  @ViewChild('fileInput') fileInput;

  $subscribeOnBase64 = new ReplaySubject(1);
  base64textString;
  isMain = false;

  // list of static types
  airports;
  roomTypes;
  superRegions;
  ToAirports;
  fromAirports;
  roomsHeader = false;
  airportsHeader = false;
  boardsHeader = false;
  minDateForOffer;

  month: number;
  day: number;
  year: number;
  // productTypes;

  // list of days non selectable
  disableDaysArray: any[] = [];

  roomTypeNumber: any[] = [];

  TempAirportsArray: any[] = [];

  TempBoardsArray: any[] = [];

  sendData: SimpleTravel;

  // validation forms arrays
  simpleTravelRoomTypeForm: any[] = [];
  simpleTravelAirportsForm: any[] = [];
  simpleTravelBoardsForm: any[] = [];

  @Input()
  travel: SimpleTravel;

  @Input()
  boardTypes: BoardType[];

  @Input()
  productTypes$: Observable<ProductType[]>;

  // roomTypes$
  lenghtOfRooms= 0;
  lenghtOfAirports = 0;
  lenghtOfBoards = 0;

  @Input()
  regions: Region[];

  @Input()
  basicEntries: any[];

  @Input()
  additionalEntries: any[];

  @Output()
  onSave = new EventEmitter;

  productTypes: ProductType[];

  basics: any[] = [];

  auxiliaries: any[] = [];

  // success = false;

  checkOutChangesCounter = 0;
  textArrived = false;

  files: FileList;
  filestring: string;

  // array of selected types for child component
  selectedBoardTypes: any[] = [];
  selectedAirportTypes: any[] = [];

  // product type code for first version
  productTypeCode
  productTypeName

  // tenant code for images
  tenantCode: string;

  // strings for pop up messages
  success: 'Erfolgreich gespeichert';
  error: 'Fehler beim Speichern';
  successOnChangeMainImage: 'Hauptbild geändert';
  errorOnChangeMainImage: 'Hauptbild konnte nicht geändert werden';
  errorOnUploading: 'Fehler beim Hochladen des Bildes';
  successOnUploading: 'Bild erfolgreich hochgeladen';
  errorOnDeteleImage: 'Fehler beim Löschen des Bildes';
  successOnDeleteImage: 'Bild erfolgreich gelöscht';
  errorOnDeleteLastDate: 'Mindestens ein Termin muss erhalten bleiben';
  errorOnDeleteLastAirport: 'Mindestens ein Flüge muss erhalten bleiben';
  errorSomeFieldNotValidDates: 'Bitte alle Pflichtfelder im Abschnitt "Termine" ausfüllen';
  errorNoDatesInOffer: 'Es wurde kein Termin erfasst. Die Reise ist daher noch ungültig.';
  errorNoAirportsInOffer: 'Es wurde kein Abflug erfasst. Die Reise ist daher noch ungültig.';
  errorSomeFieldNotValidAirports: 'Bitte alle Pflichtfelder im Abschnitt "Flüge" ausfüllen';
  errorSomeFieldNotValidBoards: 'Bitte alle Pflichtfelder im Abschnitt "Abweichende Verpflegung" ausfüllen';
  comfirmDialogForDelete: 'Wirklich löschen?';
  fileNotSelectedOnUpload: 'Bitte erst ein Bild auswählen!';
  deleteExistingImageForBasicTravel: 'You will have to delete existing picture, are you sure?';

  constructor(public simpleTravelService: SimpleTravelService,
      private router: Router,
      private route: ActivatedRoute,
      public toastr: ToastrService,
      private angularLoadingBarService: AngularLoadingBarService,
      private translate: TranslateService,
      private staticService: StaticService,
      private sharedService: SharedService,
    ) {
      super(toastr, simpleTravelService);

    this.angularLoadingBarService.start();
    this.route.params.subscribe(params => {
      let param = params['id'];
      if (param !== 'new') {
        this.sharedService.getUserTravel().subscribe(
          travelType => {
            this.userType = travelType
          })
          this.getTravelByType(this.userType, params).subscribe((travel) => {
            this.travel = travel
            console.log(JSON.stringify(travel))
            this.getRegionForSuperRegion(this.travel.accommodation.superRegion, 'yes')
            this.textArrived = true;
            if (this.travel.files.length === 0) {
              this.showGallery = false;
            }else {
              this.showGallery = true
            }
            },
            err => {this.toastr.error(this.error), this.router.navigate(['/products/simpleTravels'])});
            this.staticData()
      }else {
        this.travel = this.simpleTravelService.getSimpleTravelSkeleton()
        this.textArrived = true;
        this.sharedService.getUserTravel().subscribe(
          travel => {
            if (travel === 'simpleTravel') {
              this.premium = true;
            }else {
              this.premium = false;
            }
          })
        this.staticData()
        this.showGallery = false
      }
  })

  this.translate.onLangChange.subscribe(
    done => {  this.staticData()
      this.staticService.getProductTypes().subscribe(
        producTypes => {
          this.productTypes = producTypes
          this.productTypeCode = this.productTypes[0].code
          this.productTypeName = this.productTypes[0].name
        }
      )
     }
  );

  this.sessionData = JSON.parse(localStorage.getItem('sessionData'))
  this.tenantCode = this.sessionData.tenantCode;
  this.defaultLanguage = this.sessionData.defaultLanguage;
            window.scrollTo(0, 0);
  }

  getTravelByType(travelType, params) {
    if (travelType === 'simpleTravel') {
      this.premium = true;
      return this.simpleTravelService.getSimpleTravel(+params.id)
    }else {
      this.premium = false;
      return this.simpleTravelService.getBasicTravel(+params.id)
    }
  }

  staticData() {
      Observable.forkJoin(
       this.staticService.getSuperRegions(),
        this.staticService.getRoomTypes(),
        this.staticService.getFromAirports(),
        this.staticService.getBoardTypes()
      ).subscribe(
        data => {
          this.superRegions = data[0]
          this.roomTypes = data[1]
          this.fromAirports = data[2]
          this.boardTypes = data[3]
          this.checkRouteParams();
          this.disableSelectedAirports()
          this.disableSelectedBoardTypes()
        },
        err => this.toastr.error(this.error)
      )

  //   this.simpleTravelService.getStaticData().subscribe(
  //     data => {
  //       this.roomTypes = data.roomTypes
  //       this.superRegions = data.superRegions
  //       this.fromAirports = data.fromAirports
  //       this.boardTypes = data.boardTypes
  //       this.checkRouteParams();
  //       this.disableSelectedAirports()
  //       this.disableSelectedBoardTypes()
  //     },
  //   err => console.log(err),
  // )
}

  ngOnInit(): void {
    this.productTypes$
      .map(types => {
        return types.filter(type => { return type.rootFor.indexOf('PrdViewSimpleTravel') !== -1});
      })
      .subscribe(types => {
        this.productTypes = types
        this.productTypeCode = this.productTypes[0].code
        this.productTypeName = this.productTypes[0].name
      } );

      // get static data
    this.setDateNow()
    this.translate.getTranslation(this.translate.currentLang).subscribe(
      done => {
         this.success = done['pop-up-message'].success
         this.error = done['pop-up-message'].error
         this.successOnChangeMainImage = done['pop-up-message'].successOnChangeMainImage
         this.errorOnChangeMainImage = done['pop-up-message'].errorOnChangeMainImage
         this.errorOnUploading = done['pop-up-message'].errorOnUploading
         this.successOnUploading = done['pop-up-message'].successOnUploading
         this.errorOnDeteleImage = done['pop-up-message'].errorOnDeleteImag
         this.successOnDeleteImage = done['pop-up-message'].successOnDeleteImage
         this.errorOnDeleteLastDate = done['pop-up-message'].errorOnDeleteLastDate
         this.errorOnDeleteLastAirport = done['pop-up-message'].errorOnDeleteLastAirport
         this.errorSomeFieldNotValidDates = done['pop-up-message'].errorSomeFieldNotValidDates
         this.errorNoDatesInOffer = done['pop-up-message'].errorNoDatesInOffer
         this.errorNoAirportsInOffer = done['pop-up-message'].errorNoAirportsInOffer
         this.errorSomeFieldNotValidAirports = done['pop-up-message'].errorSomeFieldNotValidAirports
         this.errorSomeFieldNotValidBoards = done['pop-up-message'].errorSomeFieldNotValidBoards
         this.comfirmDialogForDelete = done['pop-up-message'].comfirmDialogForDelete
         this.fileNotSelectedOnUpload = done['pop-up-message'].fileNotSelectedOnUpload
         this.deleteExistingImageForBasicTravel = done['pop-up-message'].deleteExistingImageForBasicTravel
      }
    )
    this.checkLanguage();
  }

  sendDisabledDatesArray(event) {
    this.disableDaysArray = event
  }

  reloadWindow() {
    this.route.params.subscribe(params => {
      let param = params['id'];
      if (param === 'new') {
        this.router.navigate(['/products/simpleTravel/new']);
      }else {
        this.router.navigate(['/products/simpleTravel/' + this.travel.id]);
      }
    })
  }


  checkLanguage() {
    this.translate.onLangChange.subscribe(
      changed => {
      this.translate.get('pop-up-message.success').subscribe(
        done => this.success = done
      )
      this.translate.get('pop-up-message.error').subscribe(
        done => this.error = done
      )
      this.translate.get('pop-up-message.successOnChangeMainImage').subscribe(
        done => this.successOnChangeMainImage = done
      )
      this.translate.get('pop-up-message.errorOnChangeMainImage').subscribe(
        done => this.errorOnChangeMainImage = done
      )
      this.translate.get('pop-up-message.errorOnUploading').subscribe(
        done => this.errorOnUploading = done
      )
      this.translate.get('pop-up-message.successOnUploading').subscribe(
        done => this.successOnUploading = done
      )
      this.translate.get('pop-up-message.errorOnDeleteImage').subscribe(
        done => this.errorOnDeteleImage = done
      )
      this.translate.get('pop-up-message.successOnDeleteImage').subscribe(
        done => this.successOnDeleteImage = done
      )
      this.translate.get('pop-up-message.errorOnDeleteLastDate').subscribe(
        done => this.errorOnDeleteLastDate = done
      )
      this.translate.get('pop-up-message.errorOnDeleteLastAirport').subscribe(
        done => this.errorOnDeleteLastAirport = done
      )
      this.translate.get('pop-up-message.errorSomeFieldNotValidDates').subscribe(
        done => this.errorSomeFieldNotValidDates = done
      )
      this.translate.get('pop-up-message.errorNoDatesInOffer').subscribe(
        done => this.errorNoDatesInOffer = done
      )
      this.translate.get('pop-up-message.errorNoAirportsInOffer').subscribe(
        done => this.errorNoAirportsInOffer = done
      )
      this.translate.get('pop-up-message.errorSomeFieldNotValidAirports').subscribe(
        done => this.errorSomeFieldNotValidAirports = done
      )
      this.translate.get('pop-up-message.errorSomeFieldNotValidBoards').subscribe(
        done => this.errorSomeFieldNotValidBoards = done
      )
      this.translate.get('pop-up-message.comfirmDialogForDelete').subscribe(
        done => this.comfirmDialogForDelete = done
      )
      this.translate.get('pop-up-message.fileNotSelectedOnUpload').subscribe(
        done =>  this.fileNotSelectedOnUpload = done
      )
    }
    )
  }

  setDateNow() {
          // setting first date avaible for offers +14 days from current date
          let minDateForOffer = new Date();
          let numberOfDaysToAdd = 14;
          minDateForOffer.setDate(minDateForOffer.getDate() + numberOfDaysToAdd)

          this.day = minDateForOffer.getDate();
          this.month = minDateForOffer.getMonth() + 1;
          this.year = minDateForOffer.getFullYear();

          let month;
          let day;

          this.month < 10 ? month = '0' + this.month : month = this.month
          this.day < 10 ? day = '0' + this.day : day = this.day;

          this.minDateForOffer = this.year + '-' + this.month + '-' + this.day;
  }

  checkRouteParams() {
      this.route.params.subscribe(params => {
       let param = params['id'];
       if (param === 'new') {
        this.enableUpload = false;
        this.roomTypeNumber.splice(0, this.roomTypeNumber.length)
        this.TempAirportsArray.splice(0, this.TempAirportsArray.length)
        this.TempBoardsArray.splice(0, this.TempBoardsArray.length)

         if (this.checkOutChangesCounter === 0) {

         }
          this.angularLoadingBarService.complete();
       }
       if (param !== 'new') {
        this.enableUpload = true;
        // push all single room prices to main array
        // this.roomTypeNumber = new Array();
        // for (let SGL of this.travel.accommodation.roomTypes[0].prices){
        //   let tempDate = new Date(SGL.start)
        //   tempDate.setDate(tempDate.getDate() + this.travel.durVal)
        //   this.roomTypeNumber.push({
        //     roomType: this.travel.accommodation.roomTypes[0].roomType,
        //     price:  SGL.price,
        //     priceForAdmin: this.changePriceToString(SGL.price),
        //     id: SGL.id,
        //     start: SGL.start,
        //     active: SGL.active,
        //     end: tempDate
        //   })
        // }

        // // merge the same from main array and double room prices
        // for (let room of this.roomTypeNumber){
        //   for (let i = 0; i < this.travel.accommodation.roomTypes[1].prices.length; i++) {
        //     if (room.start === this.travel.accommodation.roomTypes[1].prices[i].start) {
        //       room.price1 = this.travel.accommodation.roomTypes[1].prices[i].price,
        //       room.price1ForAdmin = this.changePriceToString(this.travel.accommodation.roomTypes[1].prices[i].price),
        //       room.roomType1 = this.travel.accommodation.roomTypes[1].roomType,
        //       room.active1 = this.travel.accommodation.roomTypes[1].prices[i].active
        //       room.id1 = this.travel.accommodation.roomTypes[1].prices[i].id
        //       this.travel.accommodation.roomTypes[1].prices.splice(i, 1)
        //       i--
        //   }
        //   }
        // }

        // // push left double room prices
        // for (let DBL of this.travel.accommodation.roomTypes[1].prices){
        //   let tempDate = new Date(DBL.start)
        //   tempDate.setDate(tempDate.getDate() + this.travel.durVal)
        //   this.roomTypeNumber.push({
        //     roomType1: this.travel.accommodation.roomTypes[1].roomType,
        //     price1: DBL.price ,
        //     price1ForAdmin: this.changePriceToString(DBL.price),
        //     id1: DBL.id,
        //     start: DBL.start,
        //     active1: DBL.active,
        //     end: tempDate
        //   })
        // }


          // push all object from first array
          this.roomTypeNumber = new Array();
          let roomCounter2 = 0;
          // tslint:disable-next-line:max-line-length
          if (typeof this.travel.accommodation.roomTypes !== 'undefined' && this.travel.accommodation.roomTypes.length !== 0) {
          for (let room of this.travel.accommodation.roomTypes[0].prices){
                let tempDate = new Date(room.start)
                tempDate.setDate(tempDate.getDate() + this.travel.durVal)
              this.roomTypeNumber.push({
                    roomType: this.travel.accommodation.roomTypes[0].roomType,
                    price:  room.price,
                    priceForAdmin: this.changePriceToString(room.price),
                    currencyMaskPrice: room.price / 100,
                    id: room.id,
                    start: room.start,
                    active: room.active,
                    end: tempDate
                  })
                  roomCounter2++
              }
          }

          // copy DBL room array to temporary array
          let copyOfDoubleArray = new Array();
          if (typeof this.travel.accommodation.roomTypes !== 'undefined' && this.travel.accommodation.roomTypes.length !== 0) {
          for (let copy of this.travel.accommodation.roomTypes[1].prices){
            copyOfDoubleArray.push({
              price: copy.price,
              start: copy.start,
              id: copy.id,
              active: copy.active
            })
          }
        }

          // merge same dates from first and second array
          let roomCounter1 = 0;
          let doubleRoomIndex = 0;
          for (let room of this.roomTypeNumber){
                for (let i = 0; i < copyOfDoubleArray.length; i++) {
                if (room.start === copyOfDoubleArray[i].start) {
                  room.price1 = copyOfDoubleArray[i].price,
                  room.currencyMaskPrice1 = copyOfDoubleArray[i].price / 100,
                  room.price1ForAdmin = this.changePriceToString(copyOfDoubleArray[i].price),
                  room.roomType1 = this.travel.accommodation.roomTypes[1].roomType,
                  room.active1 = copyOfDoubleArray[i].active
                  room.id1 = copyOfDoubleArray[i].id
                  roomCounter1++
                  copyOfDoubleArray.splice(i, 1)
                  i--
              }
            }
          }

          let roomCounter3 = 0
          // push left object from second array
            for (let dbl of copyOfDoubleArray){
              roomCounter3++
                let tempDate = new Date(dbl.start)
                tempDate.setDate(tempDate.getDate() + this.travel.durVal)
                this.roomTypeNumber.push({
                  roomType1: this.travel.accommodation.roomTypes[1].roomType,
                  price1: dbl.price ,
                  currencyMaskPrice1: dbl.price / 100,
                  price1ForAdmin: this.changePriceToString(dbl.price),
                  id1: dbl.id,
                  start: dbl.start,
                  active1: dbl.active,
                  end: tempDate
                })
            }

        // set array of disabled dates for ngx-mydatepicker
            this.disableDaysArray = new Array();
            for (let test = 0; test < this.roomTypeNumber.length; test ++) {
              let tempStart = this.roomTypeNumber[test].start
              let tempDate1 = new Date(tempStart)
              let dd = tempDate1.getDate();
              let mm = tempDate1.getMonth() + 1;
              let y = tempDate1.getFullYear();
              this.roomTypeNumber[test].newStart =  { date: { year: y, month: mm, day: dd } };
                          this.disableDaysArray.push({
                            year: y, month: mm, day: dd
                          })
            }
            // boards
            let boardCount = 0;
            if (typeof this.travel.accommodation.boardUpgrades !== 'undefined') {
              for (let br = 0; br < this.travel.accommodation.boardUpgrades.length; br ++) {
                  this.TempBoardsArray.push({
                    active: this.travel.accommodation.boardUpgrades[br].active,
                    boardType: this.travel.accommodation.boardUpgrades[br].boardType,
                    price: this.travel.accommodation.boardUpgrades[br].price,
                    currencyMaskPrice: this.travel.accommodation.boardUpgrades[br].price / 100,
                    priceForAdmin: this.changePriceToString(this.travel.accommodation.boardUpgrades[br].price),
                    id: this.travel.accommodation.boardUpgrades[br].id,
                    deleteEntry: this.travel.accommodation.boardUpgrades[br].deleteEntry
                  })
                  boardCount++
              }
            }
            this.TempBoardsArray.splice(boardCount, this.TempBoardsArray.length)
            this.lenghtOfBoards = this.TempBoardsArray.length

              // airports
              if (this.premium) {
              let airportCounter = 0;
              for (let br = 0; br < this.travel.flight.fromAirports.length; br ++) {
                this.TempAirportsArray.push({
                  active: this.travel.flight.fromAirports[br].active,
                  airport: this.travel.flight.fromAirports[br].airport,
                  price: this.travel.flight.fromAirports[br].price,
                  currencyMaskPrice: this.travel.flight.fromAirports[br].price / 100,
                  priceForAdmin: this.changePriceToString(this.travel.flight.fromAirports[br].price),
                  id: this.travel.flight.fromAirports[br].id
                })
                airportCounter++
              }
              this.TempAirportsArray.splice(airportCounter, this.TempAirportsArray.length)
              this.lenghtOfAirports = this.TempAirportsArray.length
            }
            this.lenghtOfRooms = this.roomTypeNumber.length
            this.angularLoadingBarService.complete();
      } })
  }

  disableSelectedAirports() {
    this.selectedAirportTypes = []; // when changing language it must be empty
     let airportCopyCount = 0;
     for (let airport of this.fromAirports){
       this.selectedAirportTypes.push({
           code: airport.code,
           country: airport.country,
           name: airport.name,
           selectable: true
       })
       airportCopyCount++
     }
     this.selectedAirportTypes.splice(airportCopyCount, this.selectedAirportTypes.length)
    for (let airport of this.selectedAirportTypes){
      for (let selected of this.TempAirportsArray){
        if (airport.code === selected.airport) {
          airport.selectable = false;
        }
      }
    }
  }

  disableSelectedBoardTypes() {
    this.selectedBoardTypes = []; // when changing language it must be empty
      let boardCopyArrayCount1 = 0;
      for (let board of this.boardTypes){
        this.selectedBoardTypes.push({
          code: board.code,
          group: board.group,
          name: board.name,
          short: board.short,
          selectable: true
        })
        boardCopyArrayCount1++
      }
    this.selectedBoardTypes.splice(boardCopyArrayCount1, this.selectedBoardTypes.length)
     for (let board of this.selectedBoardTypes){
       for (let selected of this.TempBoardsArray){
         if (board.code === selected.boardType) {
            board.selectable = false
         }
       }
       if (board.code === this.travel.accommodation.boardType) {
        board.selectable = false;
      }
      }
  }


  getRegionForSuperRegion(region, firstTime) {
    if (firstTime === 'no') {
      this.travel.flight.toAirport = '';
      this.travel.accommodation.region = '';
    }
      // get regions for superRegion
      this.staticService.getRegionsBySuperRegions(region)
          .subscribe(
              data => this.regions = data,
              err => console.log(err),
              () => console.log('complete')
          )

      // get airports for superRegion
      this.staticService.getAirportsBySuperRegion(region)
          .subscribe(
            data => this.airports = data,
            err => console.log(err),
            () => console.log('complete')
          )
  }

  // setting selectable in boards array
  setNewSelectableBoard(boardType) {
    this.selectedBoardTypes = boardType;
  }

    // setting selectable in flight array
  setNewSelectableAirport(fromAirport) {
    this.selectedAirportTypes = fromAirport
  }

  boardChanged(event) {
    for (let board of this.selectedBoardTypes){
      if (board.code === this.travel.accommodation.boardType) {
          board.selectable = true;
      }
      if (board.code === event) {
        board.selectable = false;
      }
    }
  }

  changePriceToString(price) {
   let priceString = price.toString();
    if (priceString.length === 1) {
      return '0,0' + priceString;
    } else if (priceString.lenght === 2 ) {
      return '0,' + priceString
    } else {
      return priceString.slice(0, priceString.length - 2) + ',' + priceString.slice(priceString.length - 2)
    }
  }

  addAirports(): void {
    this.TempAirportsArray.push({
      airport: '',
      active: true,
      id: null,
      price: 0,
      currencyMaskPrice: 0
    })
    this.airportsHeader = true;
    this.lenghtOfAirports++;
  }

  addBoardUpgrades(): void {
    this.TempBoardsArray.push({
      id: null,
      boardType: '',
      price: 0,
      active: true,
      currencyMaskPrice: 0
    })

    this.boardsHeader = true;
    if (this.lenghtOfBoards === 0) {
      this.travel.accommodation.boardUpgrades = [];
      this.travel.accommodation.boardUpgrades.push({
        id: null,
        boardType: '',
        price: 0,
        active: true,
        deleteEntry: false
      })
    }
    this.lenghtOfBoards++;
  }

  addAuxiliary(): void {
    this.auxiliaries.push({
      type: '',
      service: '',
      price: 0,
      active: true
    });
  }

  copyAuxiliary(data) {
    this.auxiliaries.splice(data.index, 0, {
      type: data.auxiliary.type,
      service: data.auxiliary.service,
      price: data.auxiliary.price,
      active: data.auxiliary.active
    })
  }

  deleteAuxiliary(index) {
    this.auxiliaries.splice(index, 1)
  }

  addRooms(): void {
    this.roomTypeNumber.push({
      id: null,
      id1: null,
      roomType: 'SGL',
      roomType1: 'DBL',
      start: '',
      price: 0,
      price1: 0,
      active: true,
      active1: true,
      newStart: '',
      deleteEntry: false,
      currencyMaskPrice: 0,
      currencyMaskPrice1: 0
      })
    this.roomsHeader = true;
    this.lenghtOfRooms ++
  }

  copyRooms(data) {
    this.roomTypeNumber.splice(data.index, 0, {
          id: null,
          id1: null,
          roomType: data.basic.roomType,
          roomType1: data.basic.roomType1,
          start: '',
          price: data.basic.price,
          price1: data.basic.price1,
          priceForAdmin: data.basic.priceForAdmin,
          price1ForAdmin: data.basic.price1ForAdmin,
          active: data.basic.active,
          active1: data.basic.active1,
          end: '',
          newStart: ''
    })
    this.lenghtOfRooms ++
  }

  deleteRoom(data) {
      // tslint:disable-next-line:max-line-length
      // let response = this.deleteAssignmentFromProduct(data, this.roomTypeNumber, this.travel, this.lenghtOfRooms, 'roomType', this.success, this.error, this.errorOnDeleteLastDate)
     let response = this.deleteRoomTypes(data, this.roomTypeNumber, this.errorOnDeleteLastDate, this.travel, this.success)

     this.getRoomResponse().subscribe(
       done => {
         this.lenghtOfRooms = done['tempRoomsArray'].length;
         this.travel = done['travel'];
         this.roomTypeNumber = done['tempRoomsArray']
       }
     )
  }

  deleteBoardById(data) {
   // tslint:disable-next-line:max-line-length
    let response = this.deleteAssignmentFromProduct(data, this.TempBoardsArray, this.travel, this.lenghtOfBoards, 'boards', this.success, this.error)
   this.lenghtOfBoards = response.lengthOfAssignmentResponse;
   this.travel = response.travel;
   this.TempBoardsArray = response.tempArrayOfAssignment
  }

  copyBoardArray(data) {
    this.TempBoardsArray.splice(data.index, 0, {
      id: null,
      boardType: data.auxiliary.boardType,
      price: data.auxiliary.price,
      active: data.auxiliary.active,
      priceForAdmin: data.auxiliary.priceForAdmin
    })
    this.lenghtOfBoards++;
  }

  copyAirportArray(data) {
    this.TempAirportsArray.splice(data.index, 0, {
      airport: data.auxiliary.airport,
      active: data.auxiliary.active,
      id: null,
      price: data.auxiliary.price,
      priceForAdmin: data.auxiliary.priceForAdmin
    })
    this.lenghtOfAirports++;
  }

  deleteAirport(data) {
    // tslint:disable-next-line:max-line-length
    let response = this.deleteAssignmentFromProduct(data, this.TempAirportsArray, this.travel, this.lenghtOfAirports, 'airports', this.success, this.error, this.errorOnDeleteLastAirport)
   this.lenghtOfAirports = response.tempArrayOfAssignment.length;
   this.travel = response.travel;
   this.TempAirportsArray = response.tempArrayOfAssignment
  }

  roomFormValid(valid) {
    this.simpleTravelRoomTypeForm.push(valid)
    this.simpleTravelRoomTypeForm.splice(0, this.simpleTravelRoomTypeForm.length - this.roomTypeNumber.length)
  }

  airportFormValid(valid) {
    this.simpleTravelAirportsForm.push(valid)
    this.simpleTravelAirportsForm.splice(0, this.simpleTravelAirportsForm.length - this.lenghtOfAirports)
  }

  boardFormValid(valid) {
    this.simpleTravelBoardsForm.push(valid)
    this.simpleTravelBoardsForm.splice(0, this.simpleTravelBoardsForm.length - this.lenghtOfBoards)
  }

  saveTravel() {
  let allTypesValidationProperty = true
    if (typeof this.roomComponent !== 'undefined') {
      this.roomComponent.checkIfValid();
    }else {
      allTypesValidationProperty = false;
    }
    if (this.premium === true) {
      if (typeof this.airportComponent !== 'undefined') {
        this.airportComponent.checkIfValid();
      }else {
        allTypesValidationProperty = false;
      }
    }
    if (this.premium === true) {
    if (typeof this.boardComponent !== 'undefined') {
      this.boardComponent.checkIfValid();
      }
    }

    let firstID = null;
    let secondID = null;
    if (this.travel.accommodation.roomTypes.length > 0) {
    firstID = this.travel.accommodation.roomTypes[0].id === undefined ? null : this.travel.accommodation.roomTypes[0].id
    secondID = this.travel.accommodation.roomTypes[1].id === undefined ? null : this.travel.accommodation.roomTypes[1].id
    }
    this.travel.accommodation.roomTypes = new Array();

    let RoomPrice1 = new Array()
    let RoomPrice = new Array()

    this.travel.accommodation.roomTypes.push({
      id:  firstID,
      roomType: 'SGL',
      prices: RoomPrice1
    })
    this.travel.accommodation.roomTypes.push({
      id: secondID,
      roomType: 'DBL',
      prices: RoomPrice
    })

for (let br = 0; br < this.roomTypeNumber.length; br ++) {

  if (this.roomTypeNumber[br].roomType === 'SGL' ||  this.roomTypeNumber[br].roomType1 === 'SGL') {
    let objIndex;
    this.roomTypeNumber[br].roomType === 'SGL' ? objIndex = '' : objIndex = '1'
        this.travel.accommodation.roomTypes[0].prices.push({
          id: this.roomTypeNumber[br]['id' + objIndex],
          price: this.roomTypeNumber[br]['price' + objIndex],
          start: this.roomTypeNumber[br]['start' + objIndex],
          active: this.roomTypeNumber[br]['active' + objIndex],
          deleteEntry: this.roomTypeNumber[br].deleteEntry
        })
  }
  if (this.roomTypeNumber[br].roomType === 'DBL' || this.roomTypeNumber[br].roomType1 === 'DBL') {
      let objIndex;
      this.roomTypeNumber[br].roomType === 'DBL' ? objIndex = '' : objIndex = '1'
        this.travel.accommodation.roomTypes[1].prices.push({
          id: this.roomTypeNumber[br]['id' + objIndex],
          price: this.roomTypeNumber[br]['price' + objIndex],
          start: this.roomTypeNumber[br]['start'],
          active: this.roomTypeNumber[br]['active' + objIndex],
          deleteEntry: this.roomTypeNumber[br].deleteEntry
        })
  }
}

if (this.premium) {
  this.travel.flight.fromAirports.splice(0, this.travel.flight.fromAirports.length )
  this.travel.flight.fromAirports = new Array();
  for (let i = 0; i < this.TempAirportsArray.length; i ++) {
      this.travel.flight.fromAirports.push({
        active: this.TempAirportsArray[i].active,
        airport: this.TempAirportsArray[i].airport,
        price: this.TempAirportsArray[i].price,
        id: this.TempAirportsArray[i].id,
        deleteEntry: this.TempAirportsArray[i].deleteEntry
      })
  }
}

if (typeof this.travel.accommodation.boardUpgrades !== 'undefined') {
  this.travel.accommodation.boardUpgrades.splice(0, this.travel.accommodation.boardUpgrades.length)
  this.travel.accommodation.boardUpgrades = new Array();
  for (let i = 0; i < this.TempBoardsArray.length; i ++) {
      this.travel.accommodation.boardUpgrades.push({
        active: this.TempBoardsArray[i].active,
        boardType: this.TempBoardsArray[i].boardType,
        price: this.TempBoardsArray[i].price,
        id: this.TempBoardsArray[i].id,
        deleteEntry: this.TempBoardsArray[i].deleteEntry
      })
  }
}

  for (let br = 0; br <  this.simpleTravelRoomTypeForm.length; br ++) {
    if (this.simpleTravelRoomTypeForm[br] === false) {
      allTypesValidationProperty = false;
      this.toastr.error(this.errorSomeFieldNotValidDates);
      break;
      }
  }
  if (this.lenghtOfRooms === 0) {
    this.toastr.error(this.errorNoDatesInOffer);
  }

  this.simpleTravelRoomTypeForm.splice(0,  this.simpleTravelRoomTypeForm.length)

  for (let br = 0; br <  this.simpleTravelAirportsForm.length; br ++) {
    if (this.simpleTravelAirportsForm[br] === false) {
      allTypesValidationProperty = false;
      this.toastr.error(this.errorSomeFieldNotValidAirports);
      break;
      }
  }
  if (this.lenghtOfAirports === 0) {
    if (this.premium === true) {
      this.toastr.error(this.errorNoAirportsInOffer);
    }
  }

  this.simpleTravelAirportsForm.splice(0, this.simpleTravelAirportsForm.length)

  if (typeof this.travel.accommodation.boardUpgrades !== 'undefined') {
  for (let br = 0; br <  this.simpleTravelBoardsForm.length; br ++) {
    if (this.simpleTravelBoardsForm[br] === false) {
      allTypesValidationProperty = false;
      this.toastr.error(this.errorSomeFieldNotValidBoards);
      break;
      }
  }
  if (this.lenghtOfBoards === 0) {
    this.travel.accommodation.boardUpgrades.splice(0, this.travel.accommodation.boardUpgrades.length )
  }
}

  this.simpleTravelBoardsForm.splice(0, this.simpleTravelBoardsForm.length)

  if (this.premium === true) {
      if (allTypesValidationProperty !== false) {
        let sessionData = JSON.parse(localStorage.getItem('sessionData'))
        let destination = sessionData.homepage.detailpage
        this.simpleTravelService.saveSimpleTravel(this.travel).subscribe(
          data => {console.log(data),
            this.router.navigate(['/products/simpleTravel/' + data.id]);
            this.toastr.success(this.success)},
          err => { console.log(err), this.toastr.error(this.error)}
        )
      }else {
        this.toastr.error(this.error)
      }
  }else {
    if (allTypesValidationProperty !== false) {
      let standardUser = new BasicTravel();
      standardUser.accommodation = new BasicSimpleTravelAccommodation();
      standardUser.accommodation.roomTypes = this.travel.accommodation.roomTypes
      standardUser.accommodation.id = this.travel.accommodation.id
      standardUser.accommodation.category = this.travel.accommodation.category
      standardUser.id = this.travel.id
      standardUser.offer = this.travel.offer
      standardUser.code = this.travel.code
      standardUser.at = this.travel.at
      standardUser.active = this.travel.active
      standardUser.supplier = this.travel.supplier
      standardUser.name = this.travel.name
      standardUser.type = this.travel.type
      standardUser.typeShort = this.travel.typeShort
      standardUser.typeName = this.travel.typeName
      standardUser.order = this.travel.order
      standardUser.durType = this.travel.durType
      standardUser.durTypeName = this.travel.durTypeName
      standardUser.durVal = this.travel.durVal
      standardUser.desc = this.travel.desc
      standardUser.firstStart = this.travel.firstStart
      standardUser.firstEnd = this.travel.firstEnd
      standardUser.tags = this.travel.tags
      standardUser.header = this.travel.header
      standardUser.subHeader = this.travel.subHeader
      standardUser.subText1 = this.travel.subText1;
      // let tempSubText = this.travel.subText1[this.defaultLanguage]
      // standardUser.subText = {}
      // standardUser.subText[this.defaultLanguage] = tempSubText;
      standardUser.shortText = this.travel.shortText
      standardUser.files = this.travel.files
      console.log(JSON.stringify(standardUser));

      this.simpleTravelService.basicSimpleTravel(standardUser).subscribe(
        data => {console.log(JSON.stringify(data)),
          this.router.navigate(['/products/simpleTravel/' + data.id]);
          this.toastr.success(this.success)},
        err => { this.toastr.error(this.error)
          console.log(err._body);

        }
      )
    }else {
      this.toastr.error(this.error)
    }
  }
  }

  onSubmit() {}

  deleteSimpleTravel() {
      this.simpleTravelService.deleteSimpleTravel(this.travel).subscribe(
    data =>  this.toastr.success(this.success),
    err =>  this.toastr.success(this.error)
    )
    this.router.navigate(['/products/simpleTravels'])
  }

  copySimpleTravel() {
    let test = this.travel
    test.id = null
    test.code = ''
    test.flight.id = null
    test.accommodation.id = null;
    if (test.flight.fromAirports.length > 0) {
      for (let i = 0; i < test.flight.fromAirports.length; i ++) {
          test.flight.fromAirports[i].id = null
      }
    }
    if (test.accommodation.boardUpgrades.length > 0) {
      for (let i = 0; i < test.accommodation.boardUpgrades.length; i++) {
        test.accommodation.boardUpgrades[i].id = null
      }
    }
    for (let i = 0; i < test.accommodation.roomTypes.length; i++) {
      test.accommodation.roomTypes[i].id = null
      for (let j = 0; j < test.accommodation.roomTypes[i].prices.length; j++) {
        test.accommodation.roomTypes[i].prices[j].id = null
      }
      for (let k = 0; k < test.accommodation.roomTypes[i].prices.length; k++) {
        test.accommodation.roomTypes[i].prices[k].id = null
      }
    }
    test.at = null
    test.offer = null;

    this.simpleTravelService.copySimpleTravel(test).subscribe(
      data =>  this.toastr.success(this.success),
      err =>  this.toastr.error(this.error)
    )
  }

  updateLongText(event) {
    this.travel.longText[this.defaultLanguage] = event;
  }

  createSimpleTravel() {
        console.log(this.travel);
        this.checkOutChangesCounter = 0;
        this.router.navigate(['/products/simpleTravel/new']);
        return Observable.of(this.simpleTravelService.getSimpleTravelSkeleton())
        .subscribe((travel) => {this.travel = travel, console.log(this.travel);
        });
  }

  uploadedImageResponse(travel) {
    this.travel = travel;
  }

  spinnerLoadingFunction(event) {
    this.spinnerLoading = event;
  }

  setTravelStatus(travel) {
    if (travel.active === true) {
      travel.active = false;
      travel.at = null;
      this.simpleTravelService.saveSimpleTravel(travel).subscribe(
        success => this.toastr.warning('Trip deactivated!'),
        err => this.toastr.error('Trip not deactivated!')
      )
    }else {
      travel.active = true;
      this.simpleTravelService.saveSimpleTravel(travel).subscribe(
        success => this.toastr.success('Trip activated!'),
        err => this.toastr.error('Trip not activated!')
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/product/simple-travel-form/simple-travel-form.component.ts